import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import Service from './services';
import Utility from './Utility';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';


class Beallitasok extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editButton: true,
      napszam: null,
      naphosszperc: null,
      tordelesszam: null,
      napkezdetora: null,
      hetvege: null,
      modalUtkozes: false,

      lekerdezesButtonLoading: false,
      saveButtonLoading: false,
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

  }

  componentDidMount() {
    this.getBeallitas();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '5' && this.props.activeTab === '5') {
      this.getBeallitas();
    }
  }

  toggleUtkozesModal = () => {
    this.setState((prevState) => { return { modalUtkozes: !prevState.modalUtkozes }; });
  }

  getBeallitas = () => {
    Service.getBeallitas((err, res) => {
      if (!err) {
        let date = new Date();
        if (res[0].naphosszperc != null) {
          date.setHours((res[0].napkezdetora == null ? 0 : res[0].napkezdetora) + res[0].naphosszperc / 60);
          date.setMinutes(res[0].naphosszperc % 60);
        } else {
          date.setHours(0);
          date.setMinutes(0);
        }
        if(res[0].napszam == null){
          res[0].napszam = 7;
        }
        if(res[0].tordelesszam == null){
          res[0].tordelesszam = 4;
        }
        if(res[0].napkezdetora == null){
          res[0].napkezdetora = 0;
        }
        if(res[0].hetvege == null){
          res[0].hetvege = true;
        }
        this.setState({
          napszam: res[0].napszam,
          naphosszperc: date,
          tordelesszam: res[0].tordelesszam,
          napkezdetora: res[0].napkezdetora,
          hetvege: res[0].hetvege
        });
      }
    });
  }

  setButtonState = () => {
    this.setState({ editButton: !this.state.editButton });
  }

  renderEditButton = () => {
    return this.state.editButton ? <ProgressButton loading={this.state.saveButtonLoading} color="success" onClick={this.setButtonState}>Módosítás</ProgressButton> : '';
  }

  renderSaveButton = () => {
    return this.state.editButton ? '' : <Button color="primary" >Mentés</Button>;
  }

  insertOrModifyBeallitas = () => {
    let beallitasObj = {};
    beallitasObj.napszam = this.state.napszam;
    if (this.state.naphosszperc == null) {
      beallitasObj.naphosszperc = null;
    } else {
      beallitasObj.naphosszperc = (this.state.naphosszperc.getHours() == 0 ? 24 : this.state.naphosszperc.getHours()) * 60
        + this.state.naphosszperc.getMinutes() - (this.state.napkezdetora == null ? 0 : this.state.napkezdetora) * 60;
    }
    beallitasObj.tordelesszam = this.state.tordelesszam;
    beallitasObj.napkezdetora = this.state.napkezdetora;
    beallitasObj.hetvege = this.state.hetvege;

    this.setState({ saveButtonLoading: true });
    Service.insertOrModifyBeallitas(beallitasObj, (err, res) => {
      if (!err) {
        this.props.globals.addSuccess('Beállítások sikeresen mentve!');
        this.setButtonState();
      }
      this.setState({ saveButtonLoading: false });
    })
    if(this.state.modalUtkozes === true){
      this.toggleUtkozesModal();
    }
  }

  saveBeallitasok = () => {
    let beallitasObj = {};
    if (this.state.naphosszperc == null) {
      beallitasObj.naphosszperc = null;
    } else {
      beallitasObj.naphosszperc = (this.state.naphosszperc.getHours() == 0 ? 24 : this.state.naphosszperc.getHours()) * 60
        + this.state.naphosszperc.getMinutes() - (this.state.napkezdetora == null ? 0 : this.state.napkezdetora) * 60;
    }
    beallitasObj.napkezdetora = this.state.napkezdetora;
    beallitasObj.hetvege = this.state.hetvege;
    this.setState({ saveButtonLoading: true });
    Service.vanUtkozes(beallitasObj.hetvege, beallitasObj.napkezdetora, beallitasObj.naphosszperc, (err, res) => {
      if (!err) {
        if(res[0] === true){
          this.toggleUtkozesModal();
        }else{
          this.insertOrModifyBeallitas();
        }
      }
      this.setState({ saveButtonLoading: false });
    })
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleTimeChange = (name, date) => {
    if (date) {
      // let minutes = date.getMinutes();
      // let deviation = minutes % 5;
      // if (deviation) {
      //   this.props.globals.addWarning("Az időpont perce csak öttel osztható szám lehet!");
      //   let correction = deviation <= 2 ? deviation : -(5 - deviation);
      //   date.setMinutes(minutes - correction);
      // }
      if (date.getHours() * 60 + date.getMinutes() <= this.state.napkezdetora * 60 && !(date.getHours() == 0 && date.getMinutes() == 0)) {
        this.props.globals.addError("A naptár záró időpontja nem lehet korábbi, vagy ugyanaz, mint a naptár kezdő órája!");
        date = null;
      }
      // A kezdet és vege mező el van állítva, majd visszaírva, hogy React re-renderelje a mezőt akkor is, amikor a tárolt érték nem változott a korrigálás után
      // Például ha 13:35-ről 13:36-ra változtat a felhasználó, akkor alapba nem lenne re-render, mert a 13:35-re korrigált érték kerül beírásra,
      // és ez az érték van a változóban eredetileg is, de felületen 13:36 fog látni a felhasználó
      this.setState({ [name]: new Date() }, () => {
        this.setState({ [name]: new Date(date) });
      });
    } else {
      this.setState({ [name]: null });
    }
  }

  render() {
    let topMarginStyle = {
      marginTop: 30,
    }
    return (
      <div>
        <RFForm onSubmit={this.saveBeallitasok}>
          <div className="row">
            <div className="col-md-3">
              <RFField
                label="Megjelenítendő napok száma:"
                name="napszam"
                value={this.state.napszam}
                numberOnlyWhole
                onChange={this.handleInputChange}
                disabled={this.state.editButton}
              />
            </div>
            <div className="col-md-3">
              <RFField
                label="Naptár kezdő óra: "
                name="napkezdetora"
                value={this.state.napkezdetora}
                numberOnlyWhole
                onChange={this.handleInputChange}
                disabled={this.state.editButton}
              />
            </div>
            {/* <div className="col-md-3">
              <Label for="naphosszperc">Naptár záró időpont:</Label>
              <TimePicker
                id='naphosszperc'
                name='naphosszperc'
                value={this.state.naphosszperc}
                onChange={(d) => { this.handleTimeChange('naphosszperc', d) }}
                disabled={this.state.editButton}
              />
            </div> */}
          </div>
          <div className="row" style={topMarginStyle}>
            <div className="col-md-3">
              <RFField
                label="Órák tördelése (hány részre legyen osztva):"
                name="tordelesszam"
                numberOnlyWhole
                value={this.state.tordelesszam}
                onChange={this.handleInputChange}
                disabled={this.state.editButton}
              />
            </div>
          </div>
          <div className="row" style={topMarginStyle}>
            <div className="col-md-3" style={{ marginLeft: 2 }}>
                <RFField
                  label="Hétvége használat"
                  type="checkbox"
                  name="hetvege"
                  checked={this.state.hetvege}
                  onChange={this.handleInputChange}
                  disabled={this.state.editButton}
                />
            </div>
          </div>
          <div className="row">
            <div className="col-md-1" style={topMarginStyle}>
              {this.renderEditButton()}
              {this.renderSaveButton()}
            </div>
          </div>
        </RFForm>
        <Modal isOpen={this.state.modalUtkozes} toggle={this.toggleUtkozesModal} className={this.props.className} backdrop="static">
          <ModalHeader>Ütközés van</ModalHeader>
          <ModalBody>Az adott beállításokkal bizonyos jövőbeli intervallumok el fognak rejtődni. Biztos menteni szeretnéd?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.saveButtonLoading} color="primary" onClick={this.insertOrModifyBeallitas}>Igen</ProgressButton>
            <Button color="secondary" onClick={this.toggleUtkozesModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

}

export default Beallitasok;